export function sortByNameAsc(a, b) {
    const aOrgName = a.name.toUpperCase();
    const bOrgName = b.name.toUpperCase();
    if (aOrgName < bOrgName) {
        return -1;
    } else if (aOrgName > bOrgName) {
        return 1;
    } else {
        return 0;
    }
  }


// WEBPACK FOOTER //
// ./src/organizations/utils.js